var lastUpdate =
  {
    month: "March",
    year: 2025
  }

export default lastUpdate;
